
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewSectionComponent } from './review-section.component';
import { ProductGradeHandModule } from '@app/shared/product/product-grade-hand/product-grade-hand.module';
import { ReviewsModule } from '@app/shared/review/reviews/reviews.module';
import { RouterModule } from '@angular/router';
import { ButtonSeparatorModule } from '../../button-separator/button-separator.module';
import { MeningButtonModule } from '@app/shared/mening-button/mening-button.module';

@NgModule({
    imports: [
        CommonModule,
        ProductGradeHandModule,
        ReviewsModule,
        RouterModule,
        ButtonSeparatorModule,
        MeningButtonModule
    ],
    exports: [
        ReviewSectionComponent
    ],
    declarations: [
        ReviewSectionComponent
    ],
    providers: []
})
export class ReviewSectionModule {
}
